import { render, staticRenderFns } from "./PointsOfExperienceBlock.vue?vue&type=template&id=6a7141b0&"
import script from "./PointsOfExperienceBlock.vue?vue&type=script&lang=js&"
export * from "./PointsOfExperienceBlock.vue?vue&type=script&lang=js&"
import style0 from "./PointsOfExperienceBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports